<template>
    <div>
        <TopAppBarDrawer></TopAppBarDrawer>
        <router-view></router-view>
        <main class="main-wrapper flex-grow-1">
            <div class="d-flex align-items-center">
                <div
                    class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
                    <div class="font-m">{{isFailRefund ? $t('1194') : $t('1132')}}</div>
                </div>
            </div>
            <div class="divider"></div>
            <!-- subtabs -->
            <div class="container container--narrow mgt-50">

                <div class="t-headline11 l-spacing72 t-line-h-27 font-m">{{isFailRefund ? $t('1195') : $t('1133')}}</div>
                <div class="t-body1 font-r l-spacing48 t-line-h-26 t-color-bodyGrayA mgt-8">{{isFailRefund ? $t('1196') : $t('1134')}}</div>
                <div class="mgt-24">
                    <!-- <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" data-mdc-auto-init="MDCTextField" :class="submitState && refundReasonInvalidCheck ? 'mdc-text-field--invalid' : ''"
                                id="inputReason">
                                
                                <input type="text" class="mdc-text-field__input"
                                    name="refundReason"
                                    v-model="refundReason"
                                    v-validate="'required'"
                                    ref="refundReason"
                                    id="refundReason"
                                    maxlength="200"
                                    
                                >
                                <div class="mdc-notched-outline">
                                    <div class="mdc-notched-outline__leading"></div>
                                    <div class="mdc-notched-outline__notch">
                                    <label for="tf-outlined" class="mdc-floating-label">
                                        {{$t('1135')}}
                                    </label>
                                    </div>
                                    <div class="mdc-notched-outline__trailing"></div>
                                </div>
                                <i class="material-icons mdc-text-field__icon">
                                    {{refundReasonValidIcon}}
                                </i>
                            </div> -->
                            
                            <!-- <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && refundReasonInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
                                <span>
                                    {{submitState && refundReasonInvalidCheck ? $t('3419') : $t('3415')}}
                                </span>
                                
                            </div> -->

                    <label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField"
							id="inputReason"
							:class="submitState && refundReasonInvalidCheck ? 'mdc-text-field--invalid' : ''"
							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="my-label-id">{{$t('1135')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input" 
								name="refundReason"
                                    v-model="refundReason"
                                    v-validate="'required'"
                                    ref="refundReason"
                                    id="refundReason"
                                    maxlength="200"
									 
								/>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line">
							 <div class="t-helper pdt-2 min-h-23" :class="submitState && refundReasonInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
                                <span>
                                    {{submitState && refundReasonInvalidCheck ? $t('3419') : $t('3415')}}
                                </span>
                                
                            </div>
						</div>
                </div>
                
                <div class="divider mgt-16 mgb-16"></div>
                <div class="t-body3 t-line-h-22 l-spacing42 t-color-bodyGrayA font-r">{{$t('1136')}}</div>

                <!-- <div class="mgt-16">
                    <div class="mdc-select mdc-select--outlined w-full mdc--select__custom" id="selectNation">
                        <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                        <select class="mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom t-body6" v-model="refundNation">
                            <option :value="null" disabled>
                                {{$t('1137')}}
                            </option>
                            <option v-for="(currency, index) in countryList" :key="index" :value="currency.key">
                                {{currency.text}}
                            </option>
                        </select>
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
				    </div>
                    
                </div> -->

                <div class="mgt-24">
                    <!-- <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" data-mdc-auto-init="MDCTextField" :class="submitState && refundBanknameInvalidCheck ? 'mdc-text-field--invalid' : ''" id="inputBankname">
                        <i class="material-icons mdc-text-field__icon">
                            {{refundBanknameValidIcon}}
                        </i>
                        <input type="text" class="mdc-text-field__input"
                            name="refundBankname"
                            v-model="refundBankname"
                            v-validate="'required'"
                            ref="refundBankname"
                            id="refundBankname"
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{$t('1138')}}
                            </label>
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                    </div>
                    <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && refundBanknameInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
                        <span>
                            {{$t('3416')}}
                        </span>
                    </div> -->

                        <label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField"
							id="inputBankname"
							:class="submitState && refundBanknameInvalidCheck ? 'mdc-text-field--invalid' : ''"
							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="my-label-id">{{$t('1138')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input" 
								name="refundBankname"
                                v-model="refundBankname"
                                v-validate="'required'"
                                ref="refundBankname"
                                id="refundBankname"
							/>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line">
							<div class="t-helper pdt-2 min-h-23" :class="submitState && refundBanknameInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
								{{$t('3416')}}
							</div>
						</div>
                        
                </div>
                <div class="mgt-24">
                    <!-- <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" data-mdc-auto-init="MDCTextField" id="inputNumber">
                        <input type="text" class="mdc-text-field__input"
                            name="refundNumber"
                            v-model="refundNumber"
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{$t('1139')}}
                            </label>
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                    </div>
                    <div class="mdc-text-field-helper-line">
                        <div class="mdc-text-field-helper-text t-color-textfieldActive t-helper font-r opacity-1 l-spacing36 t-line-h-20"
                            id="my-helper-id" >8자 이상을 사용하세요.</div>
                    </div> -->

                    <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
                        data-mdc-auto-init="MDCTextField"
                        id="inputNumber"
                        :class="submitState && refundNumberInvalidCheck ? 'mdc-text-field--invalid' : ''"
					>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="my-label-id">{{$t('1139')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input"
                                type="number" 
								name="refundNumber"
                                v-model="refundNumber"
                                v-validate="'required'"
                                ref="refundNumber"
                                id="refundNumber"
							/>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i>
                    </label>
                    <div class="mdc-text-field-helper-line">
                        <div v-if="refundNumber=='' &&  submitState==false" class="t-helper pdt-2 min-h-23" :class="refundNumber==''  && submitState==false ? 't-color-textfieldActive' : 't-color-mainBtn'">
                            {{$t('3420') }}
                        </div>
                        <div v-else class="t-helper pdt-2 min-h-23" :class="submitState && refundNumberInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
                            {{submitState && refundNumberInvalidCheck ? $t('3420') : $t('3417')}}
                        </div>
                    </div>

                </div>
                <div class="mgt-24">
                    <!-- <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full" data-mdc-auto-init="MDCTextField" id="inputName">
                        <input type="text" class="mdc-text-field__input"
                            name="refundName"
                            v-model="refundName"
                        >
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                            <label for="tf-outlined" class="mdc-floating-label">
                                {{$t('1140')}}
                            </label>
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                    </div>
                    <div class="mdc-text-field-helper-line">
                        <div class="mdc-text-field-helper-text t-color-textfieldActive t-helper font-r opacity-1 l-spacing36 t-line-h-20"
                            id="my-helper-id" >이름을 올바르게 입력하세요</div>
                    </div> -->

                    <label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
                        data-mdc-auto-init="MDCTextField"
                        id="inputName"
                        :class="submitState && refundNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
					>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="my-label-id">{{$t('1140')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input" 
								name="refundName"
                                v-model="refundName"
                                v-validate="'required'"
                                ref="refundName"
                                id="refundName"
							/>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i>
                    </label>
                    <div class="mdc-text-field-helper-line">
                        <div class="t-helper pdt-2 min-h-23" :class="submitState && refundNameInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
                            {{$t('3418')}}
                        </div>
                    </div>

                </div>  
                <div class="mgt-30 pdb-50">
                        <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="requestRefund()" @keypress="requestRefund()" tabindex="0">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label t-body2 font-r font-m"> {{$t('1141')}}</span>
                        </button>
                        <button class="mdc-button  t-color-secondaryBtnText b-radius4 mgr-8" @click="cancelRefund()" @keypress="cancelRefund()" tabindex="0">
                            <div class="mdc-button__ripple"></div>
                            <span class="mdc-button__label t-body2 font-r font-m"> {{$t('1142')}}</span>
                        </button>
                    </div>
            </div>
        </main>
    </div>
</template>

<script>
/**
 * 멤버십 - 구매 상세 환불요청 컴포넌트(membership - purchase question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select'
import {MDCTextField} from '@material/textfield'
import salesApi from '@/api/salesApi.js'
import {MDCRipple} from '@material/ripple'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
export default {
    data() {
        return {
            orderId: '',

            refundCode: '',
            orderStatus: '',
            selectNation: null,
            selectBankCode: null,
            inputReason: null,
            inputNumbert: null,
            inputName: null,
            inputBankname: null,

            refundReasonTextField: false,
            refundBanknameTextField: null,
            refundNumberTextField: null,
            refundNameTextField: null,
            submitState: false,
            refundReasonValidIcon:'',
            refundBanknameValidIcon: '',
            refundNumberValidIcon: '',
            refundNameValidIcon: '',


            refundNation: '',
            refundReason: '',
            refundBankCode: '',
            refundBankname: '',
            refundNumber: '',
            refundName: '',
            goBackPrevious: true,

            countryList:[],
            bankList: [],
            paymentMethod:''
        }
    },

    components: {
        TopAppBarDrawer
    },

   computed: {
        // 유효성 체크(validation check)
        checkValid() {
            if (this.orderStatus === 'FAIL_REFUND') {
                return !!(this.refundBankname && this.refundNumber && this.refundName)
            }else {
                return !!(this.refundReason && this.refundBankname && this.refundNumber && this.refundName)
            }
            
        },

        isFailRefund() {
            return this.orderStatus === 'FAIL_REFUND' ? true : false
        },

        refundReasonInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('refundReason')) {
                    this.refundReasonTextField = false
                    returnValue = true
                    this.refundReasonValidIcon = 'warning'
                }else {
                    this.refundReasonTextField = true
                    returnValue = false
                    this.refundReasonValidIcon = ''
                }
            }
            this.inputReason.valid === !returnValue ? '' : this.inputReason.valid = !returnValue
            return returnValue
        },

        refundBanknameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('refundBankname')) {
                    returnValue = true
                    this.refundBanknameValidIcon = 'warning'
                }else {
                    returnValue = false
                    this.refundBanknameValidIcon = ''
                }
            }
            this.inputBankname.valid === !returnValue ? '' : this.inputBankname.valid = !returnValue
            return returnValue
        },

        refundNumberInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('refundNumber')) {
                    returnValue = true
                    this.refundNumberValidIcon = 'warning'
                }else {
                    returnValue = false
                    this.refundNumberValidIcon = ''
                }
            }
            this.inputNumber.valid === !returnValue ? '' : this.inputNumber.valid = !returnValue
            return returnValue
        },

        refundNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('refundName')) {
                    returnValue = true
                    this.refundNameValidIcon = 'warning'
                }else {
                    returnValue = false
                    this.refundNameValidIcon = ''
                }
            }
            this.inputName.valid === !returnValue ? '' : this.inputName.valid = !returnValue
            return returnValue
        },
    },


    mounted() {
        this.orderId = this.$route.params.orderId
        this.setMaterialUi()
        // this.selectNation = new MDCSelect(document.querySelector('#selectNation'))
        // this.selectNation.useNativeValidation = false
        // this.selectBankCode = new MDCSelect(document.querySelector('#selectBankCode'))
        // this.selectBankCode.useNativeValidation = false
        
        if (!this.isFailRefund) {
            this.inputReason = new MDCTextField(document.querySelector('#inputReason'))
            this.inputReason.useNativeValidation = false
        }

        this.inputBankname = new MDCTextField(document.querySelector('#inputBankname'))
        this.inputBankname.useNativeValidation = false

        this.inputNumber = new MDCTextField(document.querySelector('#inputNumber'))
        this.inputNumber.useNativeValidation = false

        this.inputName = new MDCTextField(document.querySelector('#inputName'))
        this.inputName.useNativeValidation = false

        let params = {
            orderId: this.$route.params.orderId
        }
        // get order information
        salesApi.salesOrderDetail(params).then((response) => {
            let orderData = response.data.data
            
            this.refundCode = orderData.refundRequest
            this.refundReason = orderData.refundRequestReason
            this.orderStatus = orderData.status.value
            this.paymentMethod = orderData.paymentMethod
            if (orderData.refundAccount) {
                this.refundBankname = orderData.refundAccount.bank
                this.refundNumber = orderData.refundAccount.number
                this.refundName = orderData.refundAccount.name

                this.inputBankname.value = this.refundBankname
                this.inputNumber.value = this.refundNumber
                this.inputName.value = this.refundName
            }

            this.inputReason.value = this.refundReason

        }).catch((err) => {

        })

         //(get country list)
        salesApi.salesRefundCountryList().then((response) => {
            this.countryList = response.data.data
        })
        
        //환불 은행 목록(get refund bank list)
        salesApi.salesRefundBankList().then((response) => {
            this.bankList = response.data.data
        })
        
    },

    
    methods: {
        // 환불 요청 취소(cancel refund request)
        // checkRefundReasonValidation() {
        //     if(this.refundReason.length>0){
        //         this.refundReasonTextField = true
        //     } else {
        //         this.refundReasonTextField = false
        //     }
                
        // },
        cancelRefund() {
            if(this.goBackPrevious===true){
                this.$router.go(-1)
            } else {
                this.$router.push({
                    name: 'MemberPurchaseRefundList',
                })
            }
                            
        },

        // 환불 요청(request refund)
        requestRefund() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    let params = {
                        orderId: this.orderId,
                        reason: this.refundReason,
                        account : {
                            bankName: this.refundBankname,
                            number: this.refundNumber,
                            name: this.refundName,
                        }
                        //code: this.refundCode
                    }

                    let alertData = ''
                    if (this.orderStatus === 'FAIL_REFUND') {
                        alertData = {
                            title: this.$t('1143'), //계좌 정보가 저장되었습니다.
                            content: this.$t('1205') + ' ' + this.$t('1206') , //'입력된 계좌 정보가 저장되었습니다. 관리자가 확인 후 환불 금액이 개별 송금될 예정입니다.
                            accept: this.$t('1207'), //'확인',
                            
                        }
                    } else {
                        alertData = {
                            title: this.$t('1204'), //환불 요청이 완료되었습니다
                            content: this.$t('1144') + ' ' + this.$t('1145') , //'관리자가 환불 승인 시 환불 처리가 시작됩니다. 환불 요청이 관리자에 의해 반려될 수 있습니다.
                            accept: this.$t('1146'), //'닫기',
                            
                        }
                    }

                    
                    if (this.refundCode) {
                        // update refund
                        this.$alert(alertData).then(() => {
                            //this.$router.go(-1)
                            this.$router.push({
                                name: 'MemberPurchaseRefundList',
                            })
                        })
                    } else {
                        // request refund
                        this.$alert(alertData).then(() => {
                            salesApi.selesRefundRequest(params).then((response) => {
                                // this.$router.go(-1)
                                this.goBackPrevious = false;
                                    //this.$router.go(-1)
                                    this.$router.push({
                                        name: 'MemberPurchaseRefundView',
                                        params: {orderId: response.data.data.id}
                                    })
                                }).catch((error)=>{
                                    console.log(error)
                                    this.$router.go(-1)
                            })
                        }).catch((error)=>{
                            console.log(error)
                            //this.$router.go(-1)
                            salesApi.selesRefundRequest(params).then((response) => {
                                // this.$router.go(-1)
                                this.goBackPrevious = false;
                                    //this.$router.go(-1)
                                    this.$router.push({
                                        name: 'MemberPurchaseRefundView',
                                        params: {orderId: response.data.data.id}
                                    })
                                }).catch((error)=>{
                                    console.log(error)
                                    this.$router.go(-1)
                            })
                        })

                    }
                }
            })
           
        },

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    },
    
}
</script>

<style scoped>
.mdc-floating-label{
	top:24px!important;
} 
/* .mdc-floating-label.mdc-floating-label--float-above{
	top:17px!important;
} */
.mdc-select-control-custom{
	border-radius: 4px;
    padding-top: 10px;
}
</style>